/**
 * Copy text on user gesture. Uses Clipboard API when allowed; falls back to
 * execCommand for embeds where Permissions-Policy blocks navigator.clipboard.
 */
export async function copyTextToClipboard(text: string): Promise<boolean> {
  if (typeof document === 'undefined') {
    return false
  }

  const value = String(text ?? '')

  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value)
      return true
    } catch {
      /* Permissions policy or insecure context — try legacy path */
    }
  }

  try {
    const textarea = document.createElement('textarea')
    textarea.value = value
    textarea.setAttribute('readonly', 'true')
    textarea.setAttribute('aria-hidden', 'true')
    textarea.style.position = 'fixed'
    textarea.style.left = '-9999px'
    textarea.style.top = '0'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.focus()
    textarea.select()
    textarea.setSelectionRange(0, value.length)
    const copied = document.execCommand('copy')
    document.body.removeChild(textarea)
    return copied
  } catch {
    return false
  }
}
